import { onUnmounted, watch } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";

export default function useWatchOpponentReadMessage() {
  const { authUser } = useAuthUser();
  let unsubscribe: () => void = () => {};

  watch(
    authUser,
    async (newAuthUser, oldAuthUser) => {
      if (!newAuthUser) {
        unsubscribe();
        return;
      }
      if (!oldAuthUser && newAuthUser) {
        const subscription = await providers.MessageThreadsProvider.subscribeToThreadUpdated(data =>
          emitter.emit(EVENTS.MESSAGES_UPDATE_THREAD, data)
        );
        unsubscribe = () => subscription.unsubscribe();
      }
    },
    { immediate: true }
  );
  onUnmounted(() => {
    unsubscribe();
  });
}
